import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { VinculosAPI } from '../../../../shared/http-requests';
import { connect } from 'react-redux';
import VisualizadorPdfV2 from '../Home/VisualizadorPdfV2';
import { useTranslation } from 'react-i18next';
import { ConsultaHelper } from '../../../../shared/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container } from 'reactstrap';
import { securePush } from '../../../../shared/security/urlSecurity';

const RestrictedAccess = ({instituicaoRx, userSessionRx, userLocalRx}) => {
    const { codAcervo } = useParams();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true);
    const {  usa_visualizador_php } = instituicaoRx;
    const [restrictedLinks, setRestrictedLinks] = useState([]);
    const { t } = useTranslation()
    const isAuthenticated = userSessionRx || userLocalRx;

    useEffect(() => {
        if(!codAcervo)
            return;

        if(!isAuthenticated) {
            navigate(`/login?redirect=/acesso-restrito/${codAcervo}&destination=C&origin=restricted_access`);
            return;
        }

        if(codAcervo){
            VinculosAPI.buscarLinksAcervos(codAcervo).then((response) => {
                const { data } = response;
                if(data && data?.length > 0) {
                    const { links } = data[0];
                    const restricted = links.filter(link => ['acesso restrito', 'acesso restrito - visualizar'].includes(link?.descricao?.trim()?.toLowerCase()))

                    if(restricted.length > 0 ){
                        setRestrictedLinks(restricted)
                    }
                }
                setLoading(false)
            }).catch(() => {
                setLoading(false)
            })
        }
    }, [codAcervo, isAuthenticated]);


    useEffect(() => {
        if(restrictedLinks?.length > 0) {
            const firstRl = restrictedLinks[0];
            if(!firstRl.is_pdf){
                ConsultaHelper.acessarLinkAcessoRestrito(
                    codAcervo,
                    restrictedLinks[0].seq_paragrafo,
                )
            }
        }
    },[restrictedLinks])

    const renderItem = (rl, index) => {
        if(rl.is_pdf)
            return (
                <span key={rl.seq_paragrafo} className="f500">
                          <VisualizadorPdfV2
                              isOpen={index === 0}
                              codAcervo={codAcervo}
                              seqParagrafo={rl.seq_paragrafo}
                              isRestricted
                          />
                    {rl.descricao}
                </span>
            )


        return (
            <span
                key={rl.seq_paragrafo}
                className="link hover1 f500 azul"
                title={t('CliqueAcessarMaterialAcessoRestrito')}
                onClick={() =>
                    ConsultaHelper.acessarLinkAcessoRestrito(
                        codAcervo,
                        rl.seq_paragrafo,
                    )
                }
            >
              <FontAwesomeIcon icon="lock-open"  className="s13 preto70 r5" />
                {rl.descricao}
            </span>
        )

    }


    return (
        <div style={{height: '100vh', width: '100vw'}} className='d-flex justify-content-center align-items-center'>
            <Container style={{borderRadius: '8px', gap: '8px'}} className='p-4 bkbranco shadow-sm  d-flex justify-content-center align-items-center flex-column'>
                {
                    loading ? t('Carregando') : restrictedLinks?.length > 0 ?
                        restrictedLinks.map((rl, index) => (
                            renderItem(rl, index)
                        )) : <p className='text-danger'>Não existe(m) arquivos de acessos restritos para este acervo.</p>
                }
            </Container>
        </div>

    )
}

const mapStateToProps = state => ({
    instituicaoRx: state.instituicao.data,
    userSessionRx: state.auth.user,
    userLocalRx: state.authPersist.user,
});


export default connect(mapStateToProps)(RestrictedAccess);
